import React from 'react'
import { Col, Row } from 'reactstrap'

const InvoiceFooter = ({invoice}) => {
    const termsAndConditionsLink = 'https://www.werkstandby.nl/wp-content/uploads/AlgemeneVoorwaardenWerkstandby-versie-3.0.pdf'
    const IBAN = 'NL58 RABO 0197 9952 17'

    return (
        <div className={'invoice-footer'}>
            <Row className="g-3">
                <Col md={5} className="print1">
                    <h6 className="head">PAYMENT</h6>
                    <p>
                        We kindly request you to send the amount to {IBAN} with
                        the description [ {invoice?.contract?.company?.name} ] + [ {invoice?.id} ]
                    </p>
                </Col>

                <Col md={1} className='print'></Col>

                <Col md={3} className="print2">
                    <p className='mb-1'>HVW Betaal B.V.</p>
                    <p className='mb-1'>Postbus 14176</p>
                    <p className='mb-1'>3508 SG UTRECHT</p>
                    <p className='mb-1'>T: 085-2229999</p>
                </Col>

                <Col md={3} className="print3">
                    <p className='mb-1'>@:administratie@hvwbetaalbv.nl</p>
                    <p className='mb-1'>VAT: NL865743253B01</p>
                    <p className='mb-1'>KVK: 91703220</p>
                    <p className='mb-1'>IBAN: {IBAN}</p>
                </Col>
            </Row>

            <Row className='text-start mt-2 mb-5 print'>
                <a href={termsAndConditionsLink} style={{fontSize: '14px'}} className='text-info fw-bold text-decoration-underline'>
                    - terms and conditions
                </a>
            </Row>
        </div>
  )
}

export default InvoiceFooter